<template>
  <div class="right-hidden">
    <v-layout>
      <v-flex xs12 md12 lg12>
        <!-- My wallet -->
        <template>
          <v-card>
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12 class="pa-1 primary--text">
                  <span class="fw-700 font-16">{{ $t('right.myWallet') }}</span>
                </v-flex>
                <v-flex xs12 md12 lg12 v-if="!isLogin" class="pa-1">
                  <span class="font-16 fw-400 pointer">
                    <span @click="gotoRegister">{{ $t('right.signUp') }}</span>
                    <span @click="login"> / {{ $t('right.login') }}</span>
                  </span>
                </v-flex>
                <v-flex xs12 md8 lg12 v-if="isLogin" class="pa-1">
                  <span class="font-16 pointer">
                    <span class="font-28 primary--text fw-700">{{ ((user != null ? user.iobPower : 0).toFixed(2))|NumFormat }}</span>
                   <span class="font-14 fw-500">IOB Power / {{ ((user != null ? user.iobPower : 0).toFixed(2))|NumFormat }} USD</span>
                  </span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </template>
      <!-- IOB Announcements -->
        <template>
          <v-card class="mt-3">
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12 class="pa-1">
                  <span class="font-16 primary--text">{{ $t('right.iobannouncements') }}</span>
                </v-flex>
                <v-flex xs12 md8 lg12 class="pa-1">
                  <span v-for="msg in bulletinBoardData" class="font-14">
                    {{ $t(msg.before) }}<span class="primary--text">{{ msg.data|NumFormat }}</span>{{ $t(msg.after) }}
                  </span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </template>
        <!--  - - - - - - - - - - - - - - - - - - Links - - - - - - - - - - - - - - - - - - - -->
        <template>
          <v-card  class="mt-3">
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12 class="pa-1">
                  <span class="fw-700 font-16 primary--text">{{ $t('right.links') }}</span>
                </v-flex>
                <v-flex xs12 md8 lg12 class="pa-1">
                  <span class="font-14 fw-500 pointer" @click="goMyFeed">
                    {{ $t('right.myFeed') }}
                  </span>
                </v-flex>
                <v-flex xs12 md8 lg12 class="pa-1">
                  <span class="font-14 fw-500 pointer" @click="goUserData">
                    {{ $t('right.myBlog') }}
                  </span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </template>
        <!-- - - - - - - - - - - - - - - - - - -  Sort  - - - - - - - - - - - - - - - - - - -->
        <template>
          <v-card class="mt-3">
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12 class="pa-1">
                  <span class="font-16 primary--text">{{ $t('right.sort') }}</span>
                </v-flex>
                <v-flex xs12 md8 lg12 class="pa-1">
                  <span class="font-14 pointer" @click="gotoHot">
                    {{ $t('right.hot') }}
                  </span>
                </v-flex>
                <v-flex xs12 md8 lg12 class="pa-1">
                  <span class="font-14 pointer" @click="gotoNew">
                    {{ $t('right.new') }}
                  </span>
                </v-flex>
                <v-flex xs12 md8 lg12 class="pa-1">
                  <span class="font-14 pointer" @click="gotoNewsTopic">
                    {{ $t('right.industryNews') }}
                  </span>
                </v-flex>
                <v-flex xs12 md8 lg12 class="pa-1">
                  <span class="font-14 pointer" @click="findByTelegramList">
                    {{ $t('right.IOBOfficialTelegram') }}
                  </span>
                </v-flex>
                <!-- <v-flex xs12 md8 lg12>
									<span class="font-1x pointer">
										Controversial
									</span>
								</v-flex>
								<v-flex xs12 md8 lg12>
									<span class="font-1x pointer">
										Rising
									</span>
								</v-flex>
								<v-flex xs12 md8 lg12>
									<span class="font-1x pointer">
										Top picks
									</span>
								</v-flex> -->
              </v-layout>
            </v-container>
          </v-card>
        </template>
        <!-- - - - - - - - - - - - - - - -标签- - - - - - - - - - - - - -->
        <template>
          <v-card class="mt-3">
            <div class="mt-3 ml-3 mr-3">
              <label class="mt-3 primary--text font-16">
                {{$t("right.allTags")}}
              </label>
              <div class="mt-3 mb-3">
                <Tag v-for="(tag, index) in tagList" :key="tag.tagId" type="border" class="font-14">
                  <span @click="findtagposting(tag.tagName)">{{tag.tagName}}</span>
                </Tag>
              </div>
              <!-- <div class="postmiddle-right mt-3">
                <ul class="list-unstyled mb-30 text-center">
                  <li>
                    <span @click="goToTags()" class="body-2 ml-1 pointer primary--text">
                      <span>{{$t("left.showall")}}...</span>
                    </span>
                  </li>
                </ul>
              </div> -->
              <!-- <div v-show="isShowUpward" class="postmiddle-right">
                <ul class="list-unstyled mb-30 text-center">
                  <li>
                    <span @click="upwardTag" class="font-14 fw-500 ml-1 pointer primary--text">
                      <span>{{$t("left.Upward")}}</span>
                      <v-icon medium class="primary--text" style="vertical-align:middle;">keyboard_arrow_up</v-icon>
                    </span>
                  </li>
                </ul>
              </div> -->
            </div>
          </v-card>
        </template>
        <!-- - - - - - - - - - - - - - - - - - -  Hot topics - - - - - - - - - - - - - - - - - - - -->
        <template>
          <v-card class="mt-3">
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12 class="pa-1 primary--text">
                  <span class="font-16">{{$t("right.hotTopics")}}</span>
                </v-flex>
                <v-flex xs12 md8 lg12 v-for="market in marketsList" :key="market.marketId" class="pa-1">
                  <span class="font-14 pointer" @click="findByMarkets(market)">
                    {{market.name}}
                  </span>
                </v-flex>
                <v-flex xs12 md8 lg12 class="pa-1">
                  <span class="font-14 pointer" @click="findByTelegramList">
                    IOB Official Telegram
                  </span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </template>
        <!-- IOB LLC -->
        <template>
          <v-card class="mt-3">
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 md12 sm6 class="pa-1 primary--text">
                  <span class="font-16">IOB LLC</span>
                </v-flex>
                <v-flex xs12 md12 sm6 pa-1>
                  <div class="font-14 pointer" @click="goAbout">
                    {{ $t('right.about') }}
                  </div>
                </v-flex>
                <v-flex xs12 md12 sm6 pa-1>
                  <div class="font-14 pointer" @click="goIobots">
                    {{ $t('right.iobots') }}
                  </div>
                </v-flex>
                <v-flex xs12 md12 sm6 pa-1>
                  <span class="font-14 pointer" @click="goPoet">
                    {{ $t('right.poet') }}
                  </span>
                </v-flex>
                <!-- <v-flex xs12 md12 sm6 class="pa-1">
                  <span class="font-14 pointer" @click="goTeam">
                    {{ $t('right.team') }}
                  </span>
                </v-flex> -->
                <v-flex xs12 md12 sm6 pa-1>
                  <span class="font-14 pointer" @click="goIr">
                    {{ $t('right.investorRelations') }}
                  </span>
                </v-flex>
                <v-flex xs12 md12 sm6 pa-1>
                  <span class="font-14 pointer" @click="goFaq">
                    {{ $t('right.faq') }}
                  </span>
                </v-flex>
                <v-flex xs12 md12 sm6 pa-1>
                  <span class="font-14 pointer" @click="goContact">
                    {{ $t('right.contact') }}
                  </span>
                </v-flex>
                <!-- <v-flex xs12 md8 lg12 class="pa-1">
                  <span class="font-14 pointer" @click="gotoIOBllcem">
                    {{ $t('right.eventsMedia') }}
                  </span>
                </v-flex> -->
                <!-- <v-flex xs12 md8 lg12 class="pa-1">
                  <span class="font-14 pointer" @click="gotoIOBllcAdvisors">
                    {{ $t('right.advertise') }}
                  </span>
                </v-flex> -->
              </v-layout>
            </v-container>
          </v-card>
        </template>
        <!-- - - - - - - - - - - - - - - -当前价钱行情- - - - - - - - - - - - - -->
        <!-- <div style="background: #FFFFFF;border: 1px solid #EEEEEE;margin-top: 20px;">
					<div align="center">
						<span style="font-weight: bold;">CoinMarketCap</span>
						<Table  border :columns="marketColumns" :data="priceMarketList" height="200" no-data-text="No data"></Table>
					</div>
				</div> -->
        <!-- - - - - - - - - - - - - - - -协议- - - - - - - - - - - - - -->
        <!-- <div class="app-card mt-5">
					<div class="caption grey--text">
						© 2018 IOB llc – Featured on <br>
						<a class="grey--text" href="https://finance.yahoo.com/news/iob-llc-acquires-significant-stake-111000600.html" target="_blank">
							<span >finance.yahoo.com.</span></a>
							<span @click="goGDPR" class="textwidget">GDPR Statement | </span>
							<span @click="goPrivacy" class="textwidget">Privacy Statement |</span>
							<span @click="goAML" class="textwidget">AML Policy</span>
					</div>
				</div> -->
        <!-- - - - - - - - - - - - - - - -提示- - - - - - - - - - - - - -->
        <!-- <Affix :offset-top="-80" @on-change="isShowAffixDiv = !isShowAffixDiv">
					<template class="app-card mt-5">
						<div>
							<div>{{$t("right.feedbackMessage")}} {{$t("common.punctuation.period")}}</div>
						</div>
					</template>
				</Affix>
				<Affix :offset-top="30">
					<template v-show="isShowAffixDiv" class="app-card mt-5">
						<div style="margin:0 20px;">
			                <label style="font-size: 16px;border-bottom: 1px solid  #EEEEEE;display:block;text-align: center;height: 30px;line-height: 15px;font-weight: bold;" class="mt-3">
			                	{{$t("left.tags")}}
			                </label>
			                <div class="mt-3 mb-3">
			                    <Tag v-for="(tag, index) in tagList" :key="tag.tagId" type="border" color="#41B8BC" class="body-2">
			                        <span @click="findtagposting(tag.tagName)">{{tag.tagName}}</span>
			                    </Tag>
			                </div>
			                <div v-show="isShowAll" class="postmiddle-right mt-3">
			                    <ul style="list-style: none;font-size: .8rem; margin-bottom: 20px; text-align: center;">
			                        <li>
			                            <span @click="showAllTag" class="body-2 ml-1 pointer">
			                                <span >{{$t("left.showall")}}</span>
			                                <v-icon medium style="vertical-align:middle;">keyboard_arrow_down</v-icon>
			                            </span>
			                        </li>
			                    </ul>
			                </div>
			                <div v-show="isShowUpward" class="postmiddle-right">
			                    <ul style="list-style: none;font-size: .8rem;margin-bottom: 20px;text-align: center;">
			                        <li>
			                            <span @click="upwardTag" class="body-2 ml-1 pointer">
			                                <span>{{$t("left.Upward")}}</span>
			                                <v-icon medium style="vertical-align:middle;">keyboard_arrow_up</v-icon>
			                            </span>
			                        </li>
			                    </ul>
			                </div>
			            </div>
					</template>
				</Affix> -->
      </v-flex>
    </v-layout>
  </div>
</template>
<style>
#topis {
  margin-left: 15px;
  list-style: none;
}

ul#topis li {
  padding-top: 15px;
}

ul#topis li:hover {
  cursor: pointer;
}

.nickName span:hover {
  color: #41B8BC;
}

</style>
<script>
import Vue from 'vue'
import config from '../config.js'
import { mapGetters } from "vuex";
export default {
  props: ['tabname'],
  data() {
    return {
      isShowAll: false, //是否显示显示全部
      isShowUpward: false, //是否显示向上收起
      tagList: [], //显示的标签集合
      allTagList: [], //所有标签集合
      isShowAffixDiv: false,
      //查询最新的评论集合
      postingnewcommentsList: [],
      //查询最新的评论人集合
      usernewcommentsList: [],
      //价钱行情集合
      priceMarketList: [],
      priceList: [],
      marketColumns: [{
          title: 'Name',
          key: 'symbol'
        },
        {
          title: 'Price',
          key: 'price'
        },
      ],
      bulletinBoardData: [{
          before: 'header.announcement.total',
          data: 0,
          after: 'header.announcement.usersAwardMsg'
        },
        {
          before: 'header.announcement.total',
          data: 0,
          after: 'header.announcement.postsAwardMsg'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(["pageTitle", "user", "marketsDesc","marketsList"]),
    isLogin() {
      if (this.$store.state.user.token != null && this.$store.state.user.token != '') {
        return true;
      } else {
        return false;
      }
    },
  },
  created(){
    // 数字格式化
    Vue.filter('NumFormat', function(value) {
     if(!value) return '0.00';
       var intPart = Number(value).toFixed(0); //获取整数部分
       intPart = intPart > value ? intPart - 1 : intPart; // 若四舍五入进了1则减去1
       var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
       var floatPart = ".00"; //预定义小数部分
       var value2Array = value.split(".");
       //=2表示数据有小数位
       if(value2Array.length == 2) {
        floatPart = value2Array[1].toString(); //拿到小数部分
        if(floatPart.length == 1) { //补0,实际上用不着
         return intPartFormat + "." + floatPart + '0';
        } else {
         return intPartFormat + "." + floatPart;
        }
       } else {
        return intPartFormat + floatPart;
       }
    })
  },
  mounted() {
    /* localStorage.setItem("pageTitle",) */
    //加载标签
    // this.getAllTagByHot();
    //加载当前价钱行情
    // this.getPriceMarket();
    // this.$nextTick(function () {
    //     setInterval(this.getPriceMarket, 60000);
    // })

    //获取公告栏的数据
    this.getBulletinBoardData();
    // 获取20个标签
    this.getTags(20);
  },
  watch: {

  },
  methods: {
    findByTelegramList() {
      this.$router.push({ name: 'telegramusermessages' });
    },
    gotoNewsTopic(){
      this.$router.push({
        name: 'marketPosts',
        params: {
          marketsName: 'Industry News'
        }
      });
    },
    gotoRegister() {
      this.$store.state.loginModal = false;
      this.$router.push({ name: 'register' })
    },
    login() {
      if (this.$store.state.user.token == null) {
        this.$store.state.loginModal = true;
      }
    },
    //最热排序
    gotoHot() {
      //Posts
      this.$router.push({ name: 'posts' });
      this.$store.dispatch("pageTitleHandler", 'hot');
    },
    //最新排序
    gotoNew() {
      //Posts
      this.$router.push({ name: 'posts' });
      this.$store.dispatch("pageTitleHandler", 'new');
    },
    //获取公告栏的数据
    getBulletinBoardData() {
      let userApi = config.baseUrl + 'userDetail/open/count/totalAwardedIOBPower'
      this.$http.get(userApi).then(response => {
        this.bulletinBoardData[0].data = response.data.result.toFixed(2);
      });
      let postApi = config.baseUrl + 'posting/open/count/totalAwardedIOBPower'
      this.$http.get(postApi).then(response => {
        this.bulletinBoardData[1].data = response.data.result.toFixed(2);
      });
    },
    //根据id查看市场详情
    findByMarkets(market) {
      localStorage.setItem('SIP-marketsCode', market.code);
      localStorage.setItem('SIP-marketsTitle', market.name);
      this.$store.dispatch("marketsDescHandler", market.description);
      this.$router.push({
        name: 'marketPosts',
        params: {
          marketsName: market.name
        }
      });
    },
    //跳转关注页面
    goMyFeed() {
      if (this.$store.state.user.token != null && this.$store.state.user.token != '') {
        this.$router.push({ name: 'feed', params: { username: '@' + this.$store.state.user.name } })
      } else {
        this.$store.state.loginModal = true;
      }
    },
    //根据标签查找帖子
    findtagposting(tagName) {
      if (tagName != null && tagName.trim() != '') {
        this.$router.push({ name: 'tagPosts', params: { "tagName": tagName } });
      }
    },
    //查询所有标签
    getAllTagByHot() {
      this.$http.get(config.baseUrl + "tag/open/getTags/hot").then(function(successData) {
        let data = successData.data.result;
        this.allTagList = data;
        if (data.length > 20) {
          for (let i = 0; i < 20; i++) {
            //向数组中添加元素
            this.tagList = this.tagList.concat(data[i]);
          }
          this.isShowAll = true;
        } else {
          this.tagList = data;
        }
      });
    },
    // 查询20个标签
    getTags(num){
      let url= config.baseUrl + 'tag/open/getTagList/'+num
      this.$http.get(url).then(res=>{
        let data = res.data.result;
        this.tagList = data;
      });
    },
    // 跳转到所有标签
    goToTags(){
      this.$router.push({ name: 'tags' });
    },
    //显示所有
    showAllTag() {
      this.tagList = this.allTagList;
      this.isShowAll = false;
      this.isShowUpward = true;
    },
    //收起标签
    upwardTag() {
      this.tagList = [];
      for (let i = 0; i < 20; i++) {
        //向数组中添加元素
        this.tagList = this.tagList.concat(this.allTagList[i]);
      }
      this.isShowAll = true;
      this.isShowUpward = false;
    },
    //查询最新的评论
    getNewComments() {
      let userUrl = config.baseUrl + "comments/open/getNewComments";
      this.$http.get(userUrl).then((successData) => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.postingnewcommentsList = data.result.postingnewcommentsList;
          this.usernewcommentsList = data.result.usernewcommentsList;
        } else {
          this.postingnewcommentsList = [];
          this.usernewcommentsList = [];
        }

      });
    },
    goPrivacy() {
      this.$router.push({ name: 'privacy' });
    },
    goGDPR() {
      this.$router.push({ name: 'GDPR' });
    },
    goAML() {
      this.$router.push({ name: 'AML' });
    },
    goUserRequest() {
      this.$router.push({ name: 'userRequest' })
    },
    goAbout() {
      this.$router.push({ name: 'about' })
    },
    goPoet() {
      this.$router.push({ name: 'poet' })
    },
    // goTeam() {
    //   this.$router.push({ name: 'team' })
    // },
    goIr() {
      this.$router.push({ name: 'investorrelations' })
    },
    goContact() {
      this.$router.push({ name: 'contact' })
    },
    goFaq(){
      this.$router.push({ name: 'frequently-asked-questions' })
    },
    //当前价钱行情
    //   getPriceMarket(){
    //   	//Bitcoin
    //   	let url1 = "https://api.coinmarketcap.com/v2/ticker/1";
    // this.$http.get(url1).then((successData) => {
    // 	this.priceMarketList.splice(0, 0, successData.data.data);
    // 	let price1 = {price : successData.data.data.quotes.USD.price}; //新建属性
    // 	Object.assign(this.priceMarketList[0], price1);//添加属性
    // });
    // //Ethereum
    // let url2 = "https://api.coinmarketcap.com/v2/ticker/1027";
    // this.$http.get(url2).then((successData) => {
    // 	this.priceMarketList.splice(1, 0, successData.data.data);
    // 	let price2 = {price : successData.data.data.quotes.USD.price}; //新建属性
    // 	Object.assign(this.priceMarketList[1], price2);//添加属性
    // });
    // //XMCT
    // let url3 = "https://api.coinmarketcap.com/v2/ticker/2923";
    // this.$http.get(url3).then((successData) => {
    // 	this.priceMarketList.splice(2, 0, successData.data.data);
    // 	let price3 = {price : successData.data.data.quotes.USD.price}; //新建属性
    // 	Object.assign(this.priceMarketList[2], price3);//添加属性
    // });
    // //IHT Real Estate Protocol
    // let url4 = "https://api.coinmarketcap.com/v2/ticker/2552";
    // this.$http.get(url4).then((successData) => {
    // 	this.priceMarketList.splice(3, 0, successData.data.data);
    // 	let price4 = {price : successData.data.data.quotes.USD.price}; //新建属性
    // 	Object.assign(this.priceMarketList[3], price4);//添加属性
    // });
    //   },
    //根据id查看帖子详情
    findsel(commentsPostingId, commentsUserName) {
      this.$router.push({
        name: 'postingsel',
        params: {
          username: commentsUserName,
          postingId: commentsPostingId
        }
      });
    },
    //查看用户详情页面
    goUserData() {
      if (this.$store.state.user.token != null && this.$store.state.user.token != '') {
        this.$router.push({
          name: 'userData',
          params: { username: '@' + this.$store.state.user.name }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    goIobots(){
      window.open ('https://iobots.pro/', '_blank');
    }
  },

}

</script>



// WEBPACK FOOTER //
// Right.vue?4c74ae39